import styled from 'styled-components'
import { themeV2 as theme } from '@taglivros/tag-components'

export const Container = styled.div`
  display: flex;
  gap: 10px;
  padding: 10px;
  width: 700px;
  height: 450px;
  justify-content: center;

  @media (max-width: 992px) {
    width: 350px;
    height: 670px;
    flex-direction: column;
  }
`

export const CardOffer = styled.div`
  border-radius: 24px;
  background-color: ${( { themeColor } ) => theme.palette[ themeColor ]};
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  width: 50%;
  font-family: ${theme.typography[ 'text-medium-bold' ]};
  font-size: 20px;

  @media (max-width: 992px) {
    gap: 5px;
    width: 100%;
    font-size: 18px;
  }
`

export const CloseIconBackground = styled.div`
  position: absolute;
  background-color: black;
  right: 7px;
  top: 7px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  box-shadow: 3px 3px 3px black;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CloseIcon = styled.img`
  width: 200%;
  height: 200%;
  max-width: none;
  cursor: pointer;
`

export const LogoImage = styled.img`
  padding: 10px;
  height: 80px;
  .img {
    width: 216px;
    height: 65px;
  }
`

export const ActionButton = styled.a`
  background-color: ${theme.palette[ 'CTA-300' ]};
  :hover {
    background-color: ${theme.palette[ 'CTA-400' ]};
  }
  
  font-family: ${theme.typography[ 'button-medium-bold' ]};
  border-radius: 8px;
  font-weight: 700;
  color: white;
  height: 50px;
  width: 300px;
  font-size: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  @media (max-width: 992px) {
    height: 40px;
    width: 280px;
    gap: 5px;
    width: 100%;
    font-size: 20px;
  }
`

export const ActionButtonInverted = styled.a`
  background-color: white;
  &:hover {
    background-color: ${theme.palette[ 'CTA-400' ]};
    color: white;
  }
  &[disabled] {
    background-color: white;
    color: gray;
    cursor: not-allowed;
    font-size: 16px;
  }
  
  font-family: ${theme.typography[ 'button-medium-bold' ]};
  border-radius: 8px;
  font-weight: 100;
  color: ${theme.palette[ 'CTA-300' ]};
  height: 50px;
  width: 300px;
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  @media (max-width: 992px) {
    height: 40px;
    width: 280px;
    gap: 5px;
    width: 100%;
    font-size: 20px;
  }
`

export const InfoGift = styled.span`
  color: white;
  font-weight: 700;
`

export const InfoPrice = styled.span`
  color: white;
  font-weight: 700;
`

export const PriceDisplay = styled.p`
  display: flex;
  align-items: flex-end;
  color: white;
  max-height: 50px;
`

export const PriceDisplayAt = styled.p`
  align-self: flex-start;
  margin-top: -4px;
`

export const PriceDisplayValue = styled.p`
  font-size: 50px;
`

export const PriceDisplayMonth = styled.p`
  padding-bottom: 10px;
`
